/*
 *   File : nominee.js
 *   Author : https://evoqins.com
 *   Description : Nominee details card component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import { useEffect, useState, memo } from 'react';
import { differenceInYears, subDays, format } from 'date-fns';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//custom component
import { CustomPhoneInput, CustomTextInput, DatePicker } from '../Form-Elements';
import { SelectionSuggestModal } from '../Modal';
import { _formatDateFormat } from '../../Helper';
import { APIService } from '../../Service';

const NomineeCard = (props) => {

    const ID_PROOF = props.data.nominee_identity_proof;
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [selectedRelation, setSelectedRelation] = useState([]);
    const [relationError, setRelationError] = useState("");

    const [allocation, setAllocation] = useState("");
    const [allocationError, setAllocationError] = useState("");

    const [dob, setDob] = useState("");
    const [dobError, setDobError] = useState("");

    const [relationData, setRelationData] = useState(props.data);

    const [guardianName, setGuardianName] = useState("");
    const [guardianNameError, setGuardianNameError] = useState("");

    const [selectedGuardianRelation, setSelectedGuardianRelation] = useState([]);
    const [guardianRelationError, setGuardianRelationError] = useState("");

    const IS_MINOR = differenceInYears(new Date(), new Date(dob)) < 18;

    const [initialStatus, setInitialStatus] = useState(true);

    const [showRelationModal, setShowRelationModal] = useState(false);
    const [showGuardianRelationModal, setShowGuardianRelationModal] = useState(false);


    // New Data
    const [idProofNo, setIdProofNo] = useState("");
    const [idProofNoError, setIdProofNoError] = useState("");
    const [selectedIDProof, setSelectedIDProof] = useState([]);
    const [selectedIDProofError, setSelectedIDProofError] = useState("");

    const [phone, setPhone] = useState("");
    const [selectedCountryCode, setSelectedCountryCode] = useState("+91");
    const [selectedCountryLocale, setSelectedCountryLocale] = useState("IN");
    const [phoneError, setPhoneError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [showIDProofModal, setShowIDProofModal] = useState(false);

    const [countryData, setCountryData] = useState(props.countryData.countries_for_address);
    const [country, setCountry] = useState([]);
    const [countryError, setCountryError] = useState("");
    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [address, setAddress] = useState("");
    const [addressError, setAddressError] = useState("");
    const [selectedState, setSelectedState] = useState([]);
    const [stateError, setStateError] = useState("");
    const [selectedCity, setSelectedCity] = useState([]);
    const [cityError, setCityError] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [pinCodeError, setPinCodeError] = useState("");


    const [showCountryModal, setShowCountryModal] = useState(false);
    const [showStateModal, setShowStateModal] = useState(false);
    const [showCityModal, setShowCityModal] = useState(false);
    const [nomineeType, setNomineeType] = useState(IS_MINOR ? 'guardian' : 'nominee');
    const [guardianIDProof, setGuardianIDProof] = useState([]);
    const [guardianProofNo, setGuardianProofNo] = useState('');
    const [guardianProofError, setGuardianProofError] = useState('');
    const [guardianCountry, setGuardianCountry] = useState([]);
    const [guardianCountryError, setGuardianCountryError] = useState("");
    const [guardianAddress, setGuardianAddress] = useState("");
    const [guardianAddressError, setGuardianAddressError] = useState("");
    const [selectedGuardianState, setSelectedGuardianState] = useState([]);
    const [selectedGuardianCity, setSelectedGuardianCity] = useState([]);
    const [guardianCityError, setGuardianCityError] = useState("");
    const [guardianPinCode, setGuardianPinCode] = useState("");
    const [guardianPinCodeError, setGuardianPinCodeError] = useState("");
    const [guardianPhone, setGuardianPhone] = useState("");
    const [guardianPhoneError, setGuardianPhoneError] = useState("");
    const [selectedGuardianCountryCode, setSelectedGuardianCountryCode] = useState("+91");
    const [selectedGuardianCountryLocale, setSelectedGuardianCountryLocale] = useState("IN");
    const [guardianEmail, setGuardianEmail] = useState("");
    const [guardianEmailError, setGuardianEmailError] = useState("");
    const [selectedGuardianStateError, setSelectedGuardianStateError] = useState("");
    const [selectedGuardianIdProofError, setSelectedGuardianIdProofError] = useState("");
    const [nomineeId, setNomineeId] = useState(null);

    const [proofLabel, setProofLabel] = useState("ID no.*");
    const [proofLabelGuardian, setProofLabelGuardian] = useState("Guardian ID no.*");

    useEffect(() => {
        // Address details
        _getState();
    }, []);


    // Prefilling already entered data
    useEffect(() => {

        // Not wrapping with any condition to re-fill the entered data previously
        if (props.nomineeData?.nominee_id !== null) {
            setNomineeId(props.nomineeData.nominee_id);
        }
        if (props.nomineeData?.name !== null) {
            setName(props.nomineeData.name);
        }
        if (props.nomineeData.dob !== null) {
            setDob(_formatDateFormat(props.nomineeData.dob));
        };

        if (props.nomineeData?.allocation !== null) {
            setAllocation(props.nomineeData.allocation);
        }

        if (props.nomineeData?.guardian_name !== null) {
            setGuardianName(props.nomineeData.guardian_name);
        }

        if (props.nomineeData?.relation_id !== null) {
            let selected_relation = props.data.kyc_relationship.find((data) => data.id == props.nomineeData.relation_id);
            setSelectedRelation(selected_relation);
        }

        if (props.data && props.data.nominee_minor_relation) {

            if (props.nomineeData?.guardian_relationship_id !== null) {
                let selected_guardian = props.data.nominee_minor_relation.find((data) => data.id == props.nomineeData.guardian_relationship_id);
                setSelectedGuardianRelation(selected_guardian);
            }
        };

        if (props.nomineeData?.identity_proof_number) {
            setIdProofNo(props.nomineeData.identity_proof_number);
        }

        if (props.nomineeData?.identity_proof_type) {

            let selected_id_proof = ID_PROOF.find(item => item.id === props.nomineeData.identity_proof_type);
            setSelectedIDProof(selected_id_proof);


            if (props.nomineeData.identity_proof_type_text === "Aadhaar") {
                setProofLabel("Aadhaar(Last 4 Digit)");
            } else if (props.nomineeData.identity_proof_type_text === "Driving licence") {
                setProofLabel("Driving licence no");
            } else if (props.nomineeData.identity_proof_type_text === "Pan") {
                setProofLabel("Pan number");
            } else if (props.nomineeData.identity_proof_type_text === "Passport") {
                setProofLabel("Passport no");
            }

        }



        if (props.type !== 2 && props.nomineeData?.contact_detail?.phone_number) {
            setPhone(props.nomineeData.contact_detail?.phone_number);
            setSelectedCountryCode(props.nomineeData.contact_detail?.country_code);
        }

        if (props.nomineeData?.contact_detail?.email) {
            setEmail(props.nomineeData.contact_detail?.email);
        }


        if (props.nomineeData?.nominee_address?.country) {
            setCountry({ id: props.nomineeData?.nominee_address?.country_id, name: props.nomineeData?.nominee_address?.country });
        }

        if (props.nomineeData?.nominee_address?.address_line1) {
            setAddress(props.nomineeData?.nominee_address?.address_line1);
        }

        if (props.nomineeData?.nominee_address?.country_id === 251) {
            if (props.nomineeData?.nominee_address?.state_id !== null) {
                setSelectedState({ id: props.nomineeData?.nominee_address?.state_id, name: props.nomineeData?.nominee_address?.state_name });
            }
        } else {
            setSelectedState(props.nomineeData?.nominee_address?.state_name || "");
        }

        if (props.nomineeData?.nominee_address?.country_id === 251) {
            if (props.nomineeData?.nominee_address?.city !== null) {
                setSelectedCity({ id: props.nomineeData?.nominee_address?.city_id, name: props.nomineeData?.nominee_address?.city });
            }
        } else {
            setSelectedCity(props.nomineeData?.nominee_address?.city || "");
        }



        if (props.nomineeData?.nominee_address?.pincode) {
            setPinCode(props.nomineeData?.nominee_address?.pincode);
        }

        if (props.nomineeData?.guardian_id_proof_number) {
            setGuardianProofNo(props.nomineeData?.guardian_id_proof_number);
        }

        if (props.nomineeData?.guardian_id_proof_type) {

            let selected_id_proof = ID_PROOF.find(item => item.id === props.nomineeData.guardian_id_proof_type);
            setGuardianIDProof(selected_id_proof);

            if (props.nomineeData.guardian_id_proof_type_text === "Aadhaar") {
                setProofLabelGuardian("Aadhaar(Last 4 Digit)");
            } else if (props.nomineeData.guardian_id_proof_type_text === "Driving licence") {
                setProofLabelGuardian("Driving licence no");
            } else if (props.nomineeData.guardian_id_proof_type === "Pan") {
                setProofLabelGuardian("Pan number");
            } else if (props.nomineeData.guardian_id_proof_type_text === "Passport") {
                setProofLabelGuardian("Passport no");
            }

        }
        if (props.type !== 2 && props.nomineeData?.guardian_contact_detail?.phone_number !== null) {
            setGuardianPhone(props.nomineeData?.guardian_contact_detail?.phone_number);
            setSelectedGuardianCountryCode(props.nomineeData?.guardian_contact_detail?.country_code);
        }

        if (props.nomineeData?.guardian_contact_detail?.country_code !== null) {
            setSelectedGuardianCountryCode(props.nomineeData?.guardian_contact_detail?.country_code);
        }
        if (props.nomineeData?.guardian_contact_detail?.email !== null) {
            setGuardianEmail(props.nomineeData?.guardian_contact_detail?.email);
        }


        if (props.nomineeData?.guardian_address?.country !== null) {
            setGuardianCountry({ id: props.nomineeData?.guardian_address?.country_id, name: props.nomineeData?.guardian_address?.country })
        }

        if (props.nomineeData?.guardian_address?.address_line1) {
            setGuardianAddress(props.nomineeData?.guardian_address?.address_line1);
        }

        if (props.nomineeData?.guardian_address?.city_id !== null) {
            setSelectedGuardianCity({ id: props.nomineeData?.guardian_address?.city_id, name: props.nomineeData?.guardian_address?.city })
        } else if (props.nomineeData?.guardian_address?.country_id !== 251) {
            setSelectedGuardianCity(props.nomineeData?.guardian_address?.city || "");
        }

        if (props.nomineeData?.guardian_address?.state_id !== null) {
            setSelectedGuardianState({ id: props.nomineeData?.guardian_address?.state_id, name: props.nomineeData?.guardian_address?.state_name })
        } else if (props.nomineeData?.guardian_address?.country_id !== 251) {
            setSelectedGuardianState(props.nomineeData?.guardian_address?.state_name || "");
        }

        if (props.nomineeData?.guardian_address?.pincode) {
            setGuardianPinCode(props.nomineeData?.guardian_address?.pincode);
        }

        setInitialStatus(false);

    }, [props.nomineeData]);

    useEffect(() => {

        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_pan = /^[A-Z]{3}P[A-Z]{1}\d{4}[A-Z]{1}$/; // validation of PAN

        if (name == "") {
            setNameError(props.error?.name_error);
        };

        if (selectedRelation.length === 0) {
            setRelationError(props.error?.relation_id_error);
        };

        if (allocation == "") {
            setAllocationError(props.error?.allocation_error);
        }

        if (dob == "") {
            setDobError(props.error?.dob_error);
        }

        if (idProofNo === "") {
            setIdProofNoError(props.error.id_proof_no_error);
        } else if (selectedIDProof?.name === "pan" && !validate_pan.test(idProofNo)) { // Pan validation
            setIdProofNoError(props.error.id_proof_no_error);
        } else if (selectedIDProof?.name === "aadhaar" && idProofNo.length < 4) { // Aadhaar Validation
            setIdProofNoError(props.error.id_proof_no_error);
        };

        if (selectedIDProof?.length === 0) {
            setSelectedIDProofError(props.error.selected_proof_id_error);
        }


        if (IS_MINOR === false) {


            if (phone === "" || (phone?.replace(selectedCountryCode, "").replace("+", "").length !== 10 && selectedCountryCode === "+91")) {
                setPhoneError(props.error.mobile_number_error);
            }

            if (email === "" || !validate_email.test(email)) {
                setEmailError(props.error.email_error);
            }
        }

        if (props.error && IS_MINOR) {
            if (guardianName == "") {
                setGuardianNameError(props.error.guardian_name_error);
            };

            if (selectedGuardianRelation.length === 0) {
                setGuardianRelationError(props.error.guardian_relationship_id_error);
            };

            if (guardianProofNo == "") {
                setGuardianProofError(props.error.guardian_id_no_error);
            } else if (guardianIDProof?.name === "pan" && !validate_pan.test(guardianProofNo)) { // Pan validation
                setGuardianProofError(props.error.guardian_id_no_error);
            } else if (guardianIDProof?.name === "aadhaar" && guardianProofNo.length < 4) { // Aadhaar validation
                setGuardianProofError(props.error.guardian_id_no_error);
            };

            if (guardianIDProof == "") {
                setSelectedGuardianIdProofError(props.error.guardian_id_type_error);
            }

            if (guardianPhone === "" || (guardianPhone?.replace(selectedGuardianCountryCode, "").replace("+", "").length !== 10 && selectedGuardianCountryCode === "+91")) {
                setGuardianPhoneError(props.error.guardian_mobile_number_error);
            }

            if (guardianEmail == "" || !validate_email.test(guardianEmail)) {
                setGuardianEmailError(props.error.guardian_email_error);
            }

            if (guardianCountry.length === 0) {
                setGuardianCountryError(props.error.nationality_error)
            }

            if (guardianAddress === "") {
                setGuardianAddressError(props.error.address_error)
            }

            if (selectedGuardianState.length === 0 || selectedGuardianState?.id === null) {
                setSelectedGuardianStateError(props.error.state_error)
            }

            if (selectedGuardianCity.length === 0 || selectedGuardianCity?.id == null) {
                setGuardianCityError(props.error.city_error);
            }

            if (guardianPinCode === "") {
                setGuardianPinCodeError(props.error.pincode_error)
            }

        };

        // Address details
        if (country.length === 0) {
            setCountryError(props.error.nationality_error)
        }

        if (address === "") {
            setAddressError(props.error.address_error)
        }

        if (selectedState.length === 0 || selectedState?.id === null) {
            setStateError(props.error.state_error)
        }

        if (selectedCity.length === 0 || selectedCity?.id === null) {
            setCityError(props.error.city_error)
        }

        if (pinCode === "") {
            setPinCodeError(props.error.pincode_error)
        }

    }, [props, IS_MINOR]);


    // To prevent phone number input to re-render when input change - Type 2 - Profile Nominee
    useEffect(() => {
        if (props.type == 2 && props.nomineeData?.contact_detail?.phone_number !== null) {
            setPhone(props.nomineeData.contact_detail?.phone_number);
            setSelectedCountryCode(props.nomineeData.contact_detail?.country_code);
        }

        if (props.type == 2 && props.nomineeData?.guardian_contact_detail?.phone_number !== null) {
            setGuardianPhone(props.nomineeData?.guardian_contact_detail?.phone_number);
            setSelectedGuardianCountryCode(props.nomineeData?.guardian_contact_detail?.country_code);
        }

    }, []);


    useEffect(() => {
        if (props.fetchNominee === true) {

            let selected_id_proof_id = selectedIDProof?.id;
            let selected_guardian_id_proof_id = guardianIDProof?.id;

            let nominee = {
                "id": props.nomineeData?.id,
                "nominee_id": nomineeId || null,
                "name": name.length !== 0 ? name : null,
                "relation_id": selectedRelation?.length !== 0 ? selectedRelation.id : null,
                "relation": selectedRelation?.length !== 0 ? selectedRelation.name : null,
                "dob": dob?.length !== 0 ? format(dob, "dd-MM-yyyy") : null,
                "allocation": allocation?.length !== 0 ? Number(allocation) : null,
                "guardian_name": IS_MINOR && guardianName?.length !== 0 && IS_MINOR ? guardianName : null,
                "guardian_relationship_id": IS_MINOR && selectedGuardianRelation?.id ? selectedGuardianRelation.id : null,
                "guardian_relationship": IS_MINOR && selectedGuardianRelation?.name ? selectedGuardianRelation.name : null,
                "guardian_id_proof_type": IS_MINOR && guardianIDProof?.length !== 0 ? guardianIDProof.id : null,
                "guardian_id_proof_type_name": IS_MINOR && guardianIDProof?.length !== 0 ? guardianIDProof.name : null,
                "guardian_id_proof_number": IS_MINOR && guardianProofNo?.length !== 0 ? guardianProofNo : null,
                "guardian_address": {
                    "address_line1": IS_MINOR === false ? null : guardianAddress?.length ? guardianAddress : null,
                    "state_id": selectedGuardianState?.id ? selectedGuardianState.id : null,
                    "state_name": selectedGuardianState?.name ? selectedGuardianState.name : selectedGuardianState.length ? selectedGuardianState : null,
                    "city": selectedGuardianCity?.name ? selectedGuardianCity.name : selectedGuardianCity.length ? selectedGuardianCity : null,
                    "city_id": selectedGuardianCity?.id ? selectedGuardianCity.id : null,
                    "pincode": IS_MINOR === false ? null : guardianPinCode?.length !== 0 ? guardianPinCode : null,
                    "country_id": IS_MINOR === false ? null : guardianCountry?.length !== 0 ? (guardianCountry.id || null) : null,
                    "country": IS_MINOR === false ? null : guardianCountry?.length !== 0 ? (guardianCountry.name || null) : null
                },
                "guardian_contact_detail": {
                    "email": IS_MINOR === false ? null : guardianEmail ? guardianEmail : null,
                    "country_code": IS_MINOR ? (guardianPhone ? selectedGuardianCountryCode : null) : null,
                    "phone_number": guardianPhone ? guardianPhone.replace(selectedGuardianCountryCode, "").replace("+", "") : null // Ignoring extra +
                },
                "identity_proof_type": IS_MINOR ? null : selectedIDProof?.length !== 0 ? selectedIDProof?.id : null,
                "identity_proof_type_name": IS_MINOR ? null : selectedIDProof?.length !== 0 ? selectedIDProof?.name : null,
                "identity_proof_number": IS_MINOR ? null : idProofNo?.length !== 0 ? idProofNo : null,
                "nominee_address": {
                    "address_line1": IS_MINOR ? null : address?.length !== 0 ? address : null,
                    "state_id": selectedState?.id ? selectedState.id : null,
                    "state_name": selectedState?.name ? selectedState.name : selectedState.length ? selectedState : null,
                    "city": selectedCity?.name ? selectedCity.name : selectedCity.length ? selectedCity : null,
                    "city_id": selectedCity?.id ? selectedCity.id : null,
                    "pincode": IS_MINOR ? null : pinCode?.length !== 0 ? pinCode : null,
                    "country_id": IS_MINOR ? null : country?.length !== 0 ? (country.id || null) : null,
                    "country": IS_MINOR ? null : country?.length !== 0 ? (country.name || null) : null,
                },
                "contact_detail": {
                    "email": IS_MINOR ? null : (email || null),
                    "country_code": IS_MINOR ? null : phone ? (selectedCountryCode || null) : null,
                    "phone_number": IS_MINOR ? null : phone ? phone.replace(selectedCountryCode, "").replace("+", "") : null // Ignoring extra +
                },

            }

            props.getNomineeData(nominee, props.index, selected_id_proof_id, selected_guardian_id_proof_id);
        }

    }, [props.fetchNominee]);

    useEffect(() => {

        if ((selectedState.id || selectedGuardianState.id) && cityData.length === 0) {
            _getCity(selectedState.id || selectedGuardianState.id);
        };

    }, [selectedState, selectedGuardianState, cityData]);

    useEffect(() => {

        if (showRelationModal === true) {
            let relation_modal = new Modal(document.getElementById(`select-suggest-modal${props.index}`));
            relation_modal.show();
        };

        if (showGuardianRelationModal) {
            let guardian_relation = new Modal(document.getElementById(`select-guardian-relation${props.index}`));
            guardian_relation.show();
        };

        if (showIDProofModal) {
            let id_proof = new Modal(document.getElementById(`select-id-proof-${props.index}`));
            id_proof.show();
        };

        if (showCountryModal) {
            let country = new Modal(document.getElementById(`nominee-country-modal-${props.index}`));
            country.show();
        }

    }, [showRelationModal, showGuardianRelationModal, showIDProofModal, showCountryModal]);


    useEffect(() => {
        if (showStateModal) {
            let state = new Modal(document.getElementById(`nominee-state-modal-${props.index}`));
            state.show();
        }
    }, [showStateModal]);

    useEffect(() => {
        if (showCityModal) {
            let city = new Modal(document.getElementById(`nominee-city-modal-${props.index}`));
            city.show();
        }
    }, [showCityModal]);

    useEffect(() => {
        if (props.data) {
            setRelationData(props.data);
        }
    }, [props.data]);

    useEffect(() => {
        setCountryData(props.countryData.countries_for_address);
    }, [props.countryData]);

    //handle nominee name change
    const _handleNameChange = (value) => {
        setName(value);
        setNameError("");
        props.onChange((value || null), props.index, "name");
    };

    //handle select relation
    const _handleSelectRelation = (value) => {
        setSelectedRelation(value);
        setRelationError("");
        props.onChange(value, props.index, "relation_id");
    };

    const _handleIDProofNumberChange = (value, minor = false) => {

        if (minor === true) {
            setGuardianProofError("");
            if (guardianIDProof.name === "pan") {
                if (value.length <= 10) {
                    setGuardianProofNo(value.toUpperCase());
                    props.onChange(value ? value.toUpperCase() : null, props.index, "guardian_id_proof_number");
                }
            } else {
                setGuardianProofNo(value);
                props.onChange(value || null, props.index, "guardian_id_proof_number");
            }
        } else {

            setIdProofNoError("");

            if (selectedIDProof.name === "pan") {
                if (value.length <= 10) {
                    setIdProofNo(value.toUpperCase());
                    props.onChange(value ? value.toUpperCase() : null, props.index, "id_proof_no");
                }
            } else {
                setIdProofNo(value);
                props.onChange(value || null, props.index, "id_proof_no");
            }
        }

    };

    //handle select ID proof
    const _handleSelectIDProof = (value) => {
        if (nomineeType === 'nominee') {
            setSelectedIDProof(value);
            setIdProofNo("");
            setSelectedIDProofError("");

            if (value.name === "aadhaar") {
                setProofLabel("Aadhaar(Last 4 Digit)");
            } else if (value.name === "driving_licence") {
                setProofLabel("Driving Licence no");
            } else if (value.name === "pan") {
                setProofLabel("Pan number");
            } else if (value.name === "passport") {
                setProofLabel("Passport no");
            }

            props.onChange(value, props.index, "selected_proof_id");

        } else {
            setGuardianIDProof(value);
            setGuardianProofNo("");
            setSelectedGuardianIdProofError("");

            if (value.name === "aadhaar") {
                setProofLabelGuardian("Aadhaar(Last 4 Digit)");
            } else if (value.name === "driving_licence") {
                setProofLabelGuardian("Driving Licence no");
            } else if (value.name === "pan") {
                setProofLabelGuardian("Pan number");
            } else if (value.name === "passport") {
                setProofLabelGuardian("Passport no");
            }

            props.onChange(value, props.index, "guardian_id_proof_type");
        }



    };

    const _handleAllocationChange = (value) => {
        let allocation = value ? Number(value) : null;
        if (allocation <= 100) {
            setAllocation(value);
            setAllocationError("");
            props.onChange(allocation, props.index, "allocation");
        }
    };

    //handle change date
    const _handleDateChange = (date) => {
        setDob(date);
        setDobError("");

        if (props.type === 2) {
            let is_minor = differenceInYears(new Date(), new Date(date)) < 18;
            props.onChange(format(date, "dd-MM-yyyy"), props.index, "dob", is_minor);
        }
    };

    const _handleGuardianNameChange = (value) => {
        setGuardianName(value);
        setGuardianNameError("");
        props.onChange(value, props.index, "guardian_name");
    };

    const _handleShowRelationModal = () => {
        setShowRelationModal(true);
    };

    const _handleShowGuardianRelationModal = () => {
        setShowGuardianRelationModal(true);
    };

    const _handleShowCountryModal = (type = 'nominee') => {
        setNomineeType(type);
        setShowCountryModal(true);
    };


    //handle select guardian relation
    const _handleSelectGuardianRelation = (value) => {
        setSelectedGuardianRelation(value);
        setGuardianRelationError("");
        props.onChange(value, props.index, "guardian_relationship_id");
    };


    // handle phone number change
    const _handlePhoneNumberChange = (value, selected_country_code, country_locale, minor = false) => {
        if (minor === true) {
            setGuardianPhone(value);
            setGuardianPhoneError("");

            if (selected_country_code) {
                setSelectedGuardianCountryCode(selected_country_code)
            }

            if (country_locale) {
                setSelectedGuardianCountryLocale(country_locale);
            }

            let phone_number = value ? value.replace((selected_country_code || selectedGuardianCountryCode), "").replace("+", "") : null // Ignoring extra +
            props.onChange({ phone_number: phone_number, country_code: selected_country_code || "+91" }, props.index, "guardian_mobile_number",);

        } else {
            setPhone(value);
            setPhoneError("");
            if (selected_country_code) {
                setSelectedCountryCode(selected_country_code);
            }

            if (country_locale) {
                setSelectedCountryLocale(country_locale);
            }

            let phone_number = value ? value.replace((selected_country_code || selectedCountryCode), "").replace("+", "") : null // Ignoring extra +
            props.onChange({ phone_number: phone_number, country_code: selected_country_code || "+91" }, props.index, "mobile_number",);
        }

    };

    //handle email change
    const _handleEmailChange = (value, minor) => {
        if (minor) {
            setGuardianEmail(value.toLowerCase());
            setGuardianEmailError("")
            props.onChange(value, props.index, "guardian_email",);
        } else {
            setEmail(value.toLowerCase());
            setEmailError("");
            props.onChange(value, props.index, "email",);

        }
    };

    //handle address change 
    const _handleAddressChange = (value, minor) => {
        if (minor === true) {
            setGuardianAddress(value)
            props.onChange(value, props.index, "guardian_address");
        } else {
            setAddress(() => value);
            props.onChange(value, props.index, "address");
        }
        setGuardianAddressError("");
        setAddressError("");
    };

    //handle  Nation
    const _handleSelectNomineeNation = (value) => {

        if (nomineeType === 'nominee') {
            if (value.id !== country?.id) {
                setCountry(value);
                setCountryError("");


                if (country.length !== 0) {
                    setStateError("");
                    setCityError("");
                    setPinCode("");
                    setPinCodeError("");
                    setAddress("");
                    setAddressError("");
                }

                if (value.id === 251) {
                    let reset = { id: null, name: "" };
                    setSelectedState(reset);
                    setSelectedCity(reset);
                } else {
                    setSelectedState("");
                    setSelectedCity("");
                }

                setPinCode("");
                setAddress("");

                props.onChange(value, props.index, "nationality",);

            }

        } else {

            if (value.id !== guardianCountry?.id) {
                setGuardianCountry(value);
                setGuardianCountryError("");


                if (guardianCountry.length !== 0) {

                    setSelectedGuardianStateError("");
                    setGuardianCityError("");
                    setGuardianPinCodeError("");
                    setGuardianPinCode("");
                    setGuardianAddress("");
                    setGuardianAddressError("");
                }

                if (value.id === 251) {
                    let reset = { id: null, name: "" };
                    setSelectedGuardianCity(reset);
                    setSelectedGuardianState(reset);
                } else {
                    setSelectedGuardianCity("");
                    setSelectedGuardianState("");
                }

                setGuardianPinCode("");
                setGuardianAddress("");

                props.onChange(value, props.index, "guardian_nationality",);

            }

        }
    };

    //handle select state
    const _handleSelectState = (value) => {
        if (nomineeType === 'nominee') {
            setSelectedState(value);
            setStateError("");
            // clearing city when state changes
            setSelectedCity({ id: null, name: "" });
            setPinCode("");

            props.onChange(value, props.index, "state");
        } else {
            setSelectedGuardianState(value);
            setSelectedGuardianStateError("");
            // clearing city when state changes
            setSelectedGuardianCity({ id: null, name: "" });
            setGuardianPinCode("");

            props.onChange(value, props.index, "guardian_state",);
        }

        setCityData([]);

    };

    //handle select city
    const _handleSelectCity = (value) => {
        if (nomineeType === 'nominee') {
            setSelectedCity(value);
            props.onChange(value, props.index, "city");
        } else {
            setSelectedGuardianCity(value);
            props.onChange(value, props.index, "guardian_city",);
        }
        setGuardianCityError("");
        setCityError("");
        setPinCode("");
    };

    // handle change state 
    const _handleChangeState = (value) => {
        if (IS_MINOR) {
            setSelectedGuardianState(value);
            props.onChange({ id: null, name: value }, props.index, "guardian_state");
        } else {
            setSelectedState(value);
            props.onChange({ id: null, name: value }, props.index, "state");
        }

        setStateError("");
        setSelectedGuardianStateError("");
    };

    // handle change state 
    const _handleChangeCity = (value) => {
        if (IS_MINOR) {
            setSelectedGuardianCity(value);
            props.onChange({ id: null, name: value }, props.index, "guardian_city");
        } else {
            setSelectedCity(value);
            props.onChange({ id: null, name: value }, props.index, "city");
        }

        setGuardianCityError("");
        setCityError("");
    };

    const _handlePinChange = (value, minor) => {
        setNomineeType(minor);
        if (minor === 'nominee') {
            setPinCode(value);
            setPinCodeError("");
            props.onChange(value, props.index, "pincode");
        } else {
            setGuardianPinCode(value)
            setGuardianPinCodeError("");
            props.onChange(value, props.index, "guardian_pincode");
        }
    };


    const _showProofModal = (type) => {
        setNomineeType(type);
        setShowIDProofModal(true)
    }

    const _openStateModal = (type) => {
        setNomineeType(type);
        setShowStateModal(true);
    }

    const _openCityModal = (type) => {
        setNomineeType(type);
        setShowCityModal(true);
    }

    //==================================== //
    //=========== API CAllS ============== //

    //API- Get state
    const _getState = () => {
        let is_post = false;
        let url = 'general/states';
        let data = null;

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStateData(response.data);
            } else {
                setStateData([]);
                // If we don't have state data
                // User cannot continue further
                toast.dismiss();
                toast.error("We are facing issue in fetching state data. Please try later", { className: "e-toast" });
            }
        });
    };

    //API- Post City
    const _getCity = (state_id) => {
        let is_post = true;
        let url = 'general/cities';
        let data = {
            "state_id": state_id,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setCityData(response.data);
            } else {
                setCityData([]);
                toast.dismiss();
                toast.error("We are facing issue in fetching city data. Please try later", { className: "e-toast" });
            }

        });
    };

    return (
        <>

            {
                initialStatus === false &&
                <div className={`${props.type == 2 ? "row row-cols-2 justify-content-between" : ""}`}>

                    {/* Nominee Detail */}

                    {/* Nominee name */}
                    <div id={`name-${props.index}`} className='h-90 mb-sm-2'>
                        <CustomTextInput label="Nominee name*"
                            placeholder="Joseph Thomas"
                            type="text"
                            value={name}
                            errorMsg={nameError}
                            className="w-100 px-3 padding-12px-top padding-12px-bottom"
                            labelStyle="e-font-weight-500"
                            handleChange={_handleNameChange} />
                    </div>

                    {/* Relationship */}
                    <div id={`relation-${props.index}`}
                        className='h-90 position-relative mb-sm-2'>
                        <CustomTextInput label="Relation*"
                            placeholder="Select relation"
                            dropdown={true}
                            type="text"
                            value={selectedRelation.name}
                            errorMsg={relationError}
                            readOnly
                            className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                            labelStyle="e-font-weight-500"
                            onClick={() => _handleShowRelationModal()} />
                    </div>

                    {/* allocation*/}
                    <div id={`allocation-${props.index}`}
                        className='h-90 mb-sm-2'>
                        <CustomTextInput label="Allocation*"
                            placeholder="Eg:50%"
                            type="number"
                            maxLength={3}
                            maxValue={100}
                            value={allocation}
                            errorMsg={allocationError}
                            className="w-100 px-3 padding-12px-top padding-12px-bottom"
                            labelStyle="e-font-weight-500"
                            handleChange={_handleAllocationChange} />
                    </div>

                    {/* Date picker */}
                    <div id={`dob-${props.index}`}>
                        <h6 className='mb-2 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                            Date of birth*
                        </h6>
                        <DatePicker value={dob}
                            error={dobError}
                            activeDate={subDays(new Date(), 1)}
                            maxDate={subDays(new Date(), 1)}
                            onChange={_handleDateChange} />
                    </div>

                    {
                        IS_MINOR === false &&
                        <>
                            {/* ID Proof type */}
                            <div id={`id-proof-type-${props.index}`}
                                className={`h-90 position-relative ${props.type === 2 ? "mt-sm-1" : "mt-sm-3"}`}>
                                <CustomTextInput label="ID proof*"
                                    placeholder="Select"
                                    dropdown={true}
                                    type="text"
                                    value={selectedIDProof?.display_name}
                                    errorMsg={selectedIDProofError}
                                    readOnly
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                                    labelStyle="e-font-weight-500"
                                    onClick={() => _showProofModal('nominee')} />
                            </div>

                            {/* ID Proof No */}
                            <div id={`id-proof-number-${props.index}`}
                                className={`h-90 ${props.type === 2 ? "mt-sm-1" : "mt-sm-2"}  mb-sm-2`}>
                                <CustomTextInput label={proofLabel}
                                    placeholder="Enter ID proof no."
                                    type={selectedIDProof?.name === "aadhaar" ? "number" : "text"} // 84 - Aadhaar
                                    maxLength={selectedIDProof?.name === "aadhaar" ? 4 : ""}
                                    value={idProofNo}
                                    errorMsg={idProofNoError}
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                    labelStyle="e-font-weight-500"
                                    handleChange={_handleIDProofNumberChange} />
                            </div>

                            {/* Phone number */}
                            <div id={`phone-number-${props.index}`}>
                                <CustomPhoneInput label="Mobile number*"
                                    id="nominee-phone-input"
                                    placeholder="9876543210"
                                    labelClass={"e-font-weight-500"}
                                    containerClassName={phoneError ? "border-red-1px  " : ""}
                                    className={phone ? `e-number-input-padding w-100 ` : `e-number-input-padding w-100`}
                                    type="text"
                                    noScrollId={props.type}
                                    value={phone}
                                    selectedCountryCode={selectedCountryCode}
                                    selectedCountryLocale={selectedCountryLocale}
                                    error={phoneError}
                                    handleChange={(value, selected_country_code, country_locale) => _handlePhoneNumberChange(value, selected_country_code, country_locale, false)} />
                            </div>

                            {/* Email ID */}
                            <div id={`email-${props.index}`} className="mb-sm-2">
                                <CustomTextInput label="Email*"
                                    placeholder="Eg: emailaddress@gmail.com"
                                    type="text"
                                    value={email}
                                    errorMsg={emailError}
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom pe-5"
                                    labelStyle="e-font-weight-500"
                                    handleChange={_handleEmailChange} />
                            </div>
                        </>
                    }




                    {/* Checking the nominee is a minor */}
                    {/* Guardian Details */}
                    {
                        IS_MINOR &&
                        <>

                            {/* Minor Info message */}
                            <p className={`${props.type === 2 ? "col-12 mt-2 mb-4" : "my-4"} e-text-onyx e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px e-border-radius-16 px-3 py-2 e-bg-cosmic-latte`} >
                                Since the nominee is a minor (under 18 years), please provide the details of a guardian to complete the nomination process.
                            </p>

                            <h3 className='col-12 mb-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                Guardian details
                            </h3>


                            {/* Nominee name */}
                            <div id={`guardian-name-${props.index}`} className='h-90 mb-sm-2'>
                                <CustomTextInput label="Guardian name*"
                                    placeholder="John Doe"
                                    type="text"
                                    value={guardianName}
                                    errorMsg={guardianNameError}
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                    labelStyle="e-font-weight-500"
                                    handleChange={_handleGuardianNameChange} />
                            </div>

                            {/*Guardian Relationship */}
                            <div id={`guardian-relation-${props.index}`}
                                className='h-90 position-relative mb-sm-2'>
                                <CustomTextInput label="Guardian relationship*"
                                    placeholder="Select relation"
                                    dropdown={true}
                                    type="text"
                                    value={selectedGuardianRelation.name}
                                    errorMsg={guardianRelationError}
                                    readOnly
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                                    labelStyle="e-font-weight-500"
                                    onClick={() => _handleShowGuardianRelationModal()} />
                            </div>

                            {/* ID Proof type */}
                            <div id={`guardian-id-proof-type-${props.index}`}
                                className={`h-90 position-relative ${props.type === 2 ? "mt-sm-1" : "mt-sm-3"}`}>
                                <CustomTextInput label="Guardian ID proof*"
                                    placeholder="Select"
                                    dropdown={true}
                                    type="text"
                                    value={guardianIDProof?.display_name}
                                    errorMsg={selectedGuardianIdProofError}
                                    readOnly
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                                    labelStyle="e-font-weight-500"
                                    onClick={() => _showProofModal('guardian')} />
                            </div>

                            {/* ID Proof No*/}
                            <div id={`guardian-id-proof-number-${props.index}`}
                                className={`h-90 ${props.type === 2 ? "mt-sm-1" : "mt-sm-2"}  mb-sm-2`}>
                                <CustomTextInput label={proofLabelGuardian}
                                    placeholder="Enter ID proof no."
                                    type={guardianIDProof?.name === "aadhaar" ? "number" : "text"} // 84 - Aadhaar
                                    maxLength={guardianIDProof?.name === "aadhaar" ? 4 : ""}
                                    value={guardianProofNo}
                                    errorMsg={guardianProofError}
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                    labelStyle="e-font-weight-500"
                                    handleChange={(value) => _handleIDProofNumberChange(value, true)} />
                            </div>

                            {/* Phone number */}
                            <div id={`guardian-phone-number-${props.index}`} className="">
                                <CustomPhoneInput label="Guardian mobile number*"
                                    id="guardian-phone-input"
                                    placeholder="9876543210"
                                    labelClass={"e-font-weight-500"}
                                    containerClassName={guardianPhoneError ? "border-red-1px  " : ""}
                                    className={guardianPhone ? `e-number-input-padding w-100 ` : `e-number-input-padding w-100`}
                                    type="text"
                                    noScrollId={props.type}
                                    value={guardianPhone}
                                    selectedCountryCode={selectedGuardianCountryCode}
                                    selectedCountryLocale={selectedGuardianCountryLocale}
                                    error={guardianPhoneError}
                                    handleChange={(value, selected_country_code, country_locale) => _handlePhoneNumberChange(value, selected_country_code, country_locale, true)} />
                            </div>

                            {/* Email ID */}
                            <div id={`gurdian-email-${props.index}`} className="mb-sm-2">
                                <CustomTextInput label="Guardian email*"
                                    placeholder="Eg: emailaddress@gmail.com"
                                    type="text"
                                    value={guardianEmail}
                                    errorMsg={guardianEmailError}
                                    className="w-100 px-3 padding-12px-top padding-12px-bottom pe-5"
                                    labelStyle="e-font-weight-500"
                                    handleChange={(value) => _handleEmailChange(value, true)} />
                            </div>

                        </>
                    }




                    {/* Address Detail - Nominee || Guardian */}
                    <>
                        <h3 className={`${props.type === 2 ? "col-12 mt-3" : "mt-4"} mb-3 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px`}>
                            {IS_MINOR ? "Gaurdian address details" : " Address details"}
                        </h3>

                        {/* Nationality select */}
                        <div id={`nationality-${props.index}`}
                            className='h-90 position-relative mb-2'>
                            <CustomTextInput label="Nationality*"
                                placeholder="India"
                                dropdown={true}
                                type="text"
                                value={IS_MINOR ? guardianCountry.name : country.name}
                                errorMsg={IS_MINOR ? guardianCountryError : countryError}
                                readOnly
                                className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                                labelStyle="e-font-weight-500"
                                onClick={() => _handleShowCountryModal(IS_MINOR ? 'guardian' : 'nominee')} />
                        </div>

                        {/* address line  */}
                        <div id={`address-${props.index}`}
                            className='h-90 mb-2'>
                            <CustomTextInput label={"Address line 1*"}
                                placeholder="202,Madhav Apts, jawar road......."
                                type="text"
                                value={IS_MINOR ? guardianAddress : address}
                                errorMsg={IS_MINOR ? guardianAddressError : addressError}
                                className='w-100 px-3 padding-12px-top padding-12px-bottom'
                                labelStyle="e-font-weight-500"
                                handleChange={(value) => _handleAddressChange(value, IS_MINOR)} />
                        </div>

                        {/* state and city */}
                        <div className={`${props.type === 2 ? "d-flex justify-content-between col-12 gap-4" : "row"}`}>
                            <div className={`${props.type === 2 ? "w-50" : "col-lg-6"}`}>
                                <div id={`state-${props.index}`}
                                    className='h-90 position-relative mb-2'>
                                    {
                                        (IS_MINOR ? guardianCountry?.id === 251 || guardianCountry.length === 0 : country?.id === 251 || country.length === 0) ?
                                            <CustomTextInput label={"State*"}
                                                placeholder="Karnataka"
                                                dropdown={true}
                                                type="text"
                                                value={IS_MINOR ? selectedGuardianState.name : selectedState.name}
                                                errorMsg={IS_MINOR ? selectedGuardianStateError : stateError}
                                                readOnly
                                                disabled={stateData.length === 0 ? true : false}
                                                className="w-100 px-3 pe-5 padding-12px-top padding-12px-bottom cursor-pointer"
                                                labelStyle="e-font-weight-500"
                                                onClick={() => _openStateModal(IS_MINOR ? 'guardian' : 'nominee')}
                                            />
                                            :
                                            <CustomTextInput label={"State*"}
                                                placeholder="Washington"
                                                type="text"
                                                value={IS_MINOR ? selectedGuardianState : selectedState}
                                                errorMsg={IS_MINOR ? selectedGuardianStateError : stateError}
                                                className="w-100 px-3 pe-5 padding-12px-top padding-12px-bottom"
                                                labelStyle="e-font-weight-500"
                                                handleChange={_handleChangeState}
                                            />
                                    }
                                </div>
                            </div>

                            {/*select city*/}
                            <div className={`${props.type === 2 ? "w-50" : "col-lg-6"}`}>
                                {
                                    (IS_MINOR ? guardianCountry?.id === 251 || guardianCountry.length === 0 : country?.id === 251 || country.length === 0) ?

                                        <div id={`city-${props.index}`}
                                            className={`${IS_MINOR ? (selectedGuardianState.id ? "" : "e-disable") : selectedState.id ? "" : "e-disable"} h-90 position-relative mb-2`}>
                                            <CustomTextInput label="City*"
                                                placeholder="Bangalore"
                                                dropdown={true}
                                                type="text"
                                                value={IS_MINOR ? selectedGuardianCity.name : selectedCity.name}
                                                errorMsg={IS_MINOR ? guardianCityError : cityError}
                                                readOnly
                                                disabled={cityData.length !== 0 ? false : true}
                                                className={`${IS_MINOR ? guardianCountry?.id === 251 : country?.id === 251 ? "cursor-pointer" : ""} w-100 px-3 pe-sm-3 pe-2 padding-12px-top padding-12px-bottom cursor-pointer`}
                                                labelStyle="e-font-weight-500"
                                                onClick={() => _openCityModal(IS_MINOR ? 'guardian' : 'nominee')} />
                                        </div>
                                        :
                                        <div id={`city-${props.index}`}
                                            className={` h-90 position-relative mb-2`}>
                                            <CustomTextInput label="City*"
                                                placeholder="Seattle"
                                                type="text"
                                                value={IS_MINOR ? selectedGuardianCity : selectedCity}
                                                errorMsg={IS_MINOR ? guardianCityError : cityError}
                                                className={` w-100 px-3 pe-sm-3 pe-2 padding-12px-top padding-12px-bottom`}
                                                labelStyle="e-font-weight-500"
                                                handleChange={_handleChangeCity} />
                                        </div>

                                }
                            </div>
                        </div>

                        {
                            IS_MINOR ?
                                <div id={`pincode-${props.index}`}
                                    className='h-90'>
                                    <CustomTextInput label={guardianCountry?.id === 251 || guardianCountry.length === 0 ? "Pincode*" : "ZipCode*"}
                                        placeholder="670676"
                                        type={(guardianCountry?.id === 251 || guardianCountry.length === 0) ? "number" : "text"}
                                        inputType={(guardianCountry?.id === 251 || guardianCountry.length === 0) ? "pincode" : "alphanumeric"}
                                        value={guardianPinCode}
                                        errorMsg={guardianPinCodeError}
                                        maxLength={guardianCountry?.id === 251 || guardianCountry.length === 0 ? 6 : 10}
                                        className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                        labelStyle="e-font-weight-500"
                                        handleChange={(value) => _handlePinChange(value, 'guardian')} />
                                </div>
                                :
                                <div id={`pincode-${props.index}`}
                                    className='h-90'>
                                    <CustomTextInput label={(country?.id === 251 || country.length === 0) ? "Pincode*" : "ZipCode*"}
                                        placeholder="670676"
                                        type={(country?.id === 251 || country.length === 0) ? "number" : "text"}
                                        inputType={(country?.id === 251 || country.length === 0) ? "pincode" : "alphanumeric"}
                                        value={pinCode}
                                        errorMsg={pinCodeError}
                                        maxLength={(country?.id === 251 || country.length === 0) ? 6 : 10}
                                        className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                        labelStyle="e-font-weight-500"
                                        handleChange={(value) => _handlePinChange(value, 'nominee')} />
                                </div>
                        }

                    </>

                </div>
            }

            {/* relation modal */}
            {
                showRelationModal &&
                <SelectionSuggestModal title="Choose a relation*"
                    data={relationData.kyc_relationship}
                    type={props.index}
                    id={`select-suggest-modal${props.index}`}
                    selectedOption={selectedRelation}
                    onSelectOption={_handleSelectRelation}
                    onModalClose={() => setShowRelationModal(false)} />
            }

            {/* relation modal */}

            {
                showGuardianRelationModal &&
                <SelectionSuggestModal title="Choose a guardian relation*"
                    data={relationData.nominee_minor_relation}
                    type={2}
                    id={`select-guardian-relation${props.index}`}
                    selectedOption={selectedGuardianRelation}
                    onSelectOption={_handleSelectGuardianRelation}
                    onModalClose={() => setShowGuardianRelationModal(false)} />
            }

            {/* ID Proof modal */}
            {
                showIDProofModal &&
                <SelectionSuggestModal title="Choose a ID proof*"
                    // data={relationData.kyc_relationship}
                    data={ID_PROOF}
                    type={props.index}
                    id={`select-id-proof-${props.index}`}
                    selectedOption={IS_MINOR ? guardianIDProof : selectedIDProof}
                    onSelectOption={_handleSelectIDProof}
                    onModalClose={() => setShowIDProofModal(false)} />
            }


            {/* Country select */}
            {
                showCountryModal &&
                <SelectionSuggestModal title="Choose a country"
                    data={countryData}
                    search
                    searchPlaceholder={"Eg : India"}
                    type={props.index}
                    id={`nominee-country-modal-${props.index}`}
                    selectedOption={IS_MINOR ? guardianCountry : country}
                    onSelectOption={_handleSelectNomineeNation}
                    onModalClose={() => setShowCountryModal(false)} />
            }

            {/* State modal*/}
            {
                showStateModal &&
                <SelectionSuggestModal title="Choose a state"
                    data={stateData}
                    type={props.index}
                    search={true}
                    id={`nominee-state-modal-${props.index}`}
                    searchPlaceholder={"Eg : Karnataka"}
                    selectedOption={nomineeType === 'nominee' ? selectedState : selectedGuardianState}
                    onSelectOption={_handleSelectState}
                    onModalClose={() => setShowStateModal(false)} />
            }

            {/* city modal */}
            {
                showCityModal &&
                <SelectionSuggestModal title="Choose a city"
                    data={cityData}
                    type={props.index}
                    search={true}
                    searchPlaceholder={"Eg : Bangalore"}
                    id={`nominee-city-modal-${props.index}`}
                    selectedOption={nomineeType === 'nominee' ? selectedCity : selectedGuardianCity}
                    onSelectOption={_handleSelectCity}
                    onModalClose={() => setShowCityModal(false)} />
            }


        </>
    )

}

export default memo(NomineeCard);

NomineeCard.defaultProps = {
    onChange: () => { },
    type: 1
}